export default __webpack_public_path__ + "static/media/Portfolio.ac6b96c1.png";